var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "m-5 md:m-15 2xl:m-20"
  }, [_c('EvalInProgress', {
    attrs: {
      "evaluation-in-progress": _vm.evaluationInProgress
    },
    on: {
      "showPreview": function ($event) {
        _vm.showPreview = true;
      },
      "massAssignation": function ($event) {
        return _vm.displayAssignTemplate();
      }
    }
  }), _vm._v(" "), _c('mass-template-assignation', {
    attrs: {
      "opened": _vm.massAssignation,
      "template": _vm.massAssignationTemplate
    },
    on: {
      "close": function ($event) {
        _vm.massAssignation = false;
      }
    }
  }), _vm._v(" "), _c('deactivate-template-popup', {
    attrs: {
      "confirm-deactivate-template": _vm.confirmDeactivateTemplate,
      "template-name-to-deactivate": _vm.templateNameToDeactivate,
      "list-assigned-users-template": _vm.listAssignedUsersTemplate,
      "template-page-to-assign-after-delete": _vm.templatePageToAssignAfterDelete
    },
    on: {
      "confirm_deactivate_template": function (templatePageToAssignAfterDelete) {
        _vm.confirm_deactivate_template(templatePageToAssignAfterDelete);
      },
      "close": function ($event) {
        _vm.confirmDeactivateTemplate = -1;
      }
    }
  }), _vm._v(" "), _c('activate-template-popup', {
    attrs: {
      "confirm-activate-template": _vm.confirmActivateTemplate,
      "template-name-to-deactivate": _vm.templateNameToDeactivate
    },
    on: {
      "confirm_activate_template": function ($event) {
        return _vm.confirm_activate_template();
      },
      "close": function ($event) {
        _vm.confirmActivateTemplate = -1;
      }
    }
  }), _vm._v(" "), _c('popup', {
    attrs: {
      "opened": _vm.showPreview
    },
    on: {
      "close": function ($event) {
        _vm.showPreview = false;
      }
    }
  }, [_c('div', {
    staticClass: "m-5 md:m-15 2xl:m-20"
  }, [_c('h3', {
    staticClass: "mb-5 md:mb-15 2xl:mb-20"
  }, [_vm._v("\n        " + _vm._s(_vm.infosPage.libelle_template) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('div', {
    staticClass: "flex flex-row self-center relative items-center cursor-pointer my-8 w-max max-w-7/12",
    on: {
      "click": [_vm.displayFieldList, function ($event) {
        $event.stopPropagation();
      }]
    }
  }, [_c('div', {
    staticClass: "flex flex-row items-end"
  }, [_c('h5', {
    staticClass: "text-indigo-600 font-normal"
  }, [_vm._v("\n              " + _vm._s('Domaine ' + (_vm.currentField + 1) + '. ' + _vm.templateContent[_vm.currentField].libelle) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "text-pink-600 max-h-8 mr-auto rounded-full relative inline-flex items-center p-2 order-2"
  }, [_c('icon', {
    staticClass: "h-4 w-4",
    attrs: {
      "name": "chevron-down"
    }
  })], 1), _vm._v(" "), _vm.showList ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.displayFieldList,
      expression: "displayFieldList"
    }],
    staticClass: "fieldlist flex z-20 mt-2 left-0 top-10 w-max max-w-full absolute rounded-md bg-white shadow-md shadow-gray-600 text-sm"
  }, [_c('div', {
    staticClass: "mx-5 my-3"
  }, [_c('div', {
    staticClass: "text-left"
  }, _vm._l(_vm.templateContent, function (field, i) {
    return _c('div', {
      key: i,
      staticClass: "first:pt-2 py-1"
    }, [_c('p', {
      staticClass: "text-gray-600 hover:text-gray-900",
      on: {
        "click": function ($event) {
          _vm.currentField = i;
        }
      }
    }, [_c('span', [_vm._v(_vm._s('Domaine ' + (i + 1) + ' : ' + field.libelle))])])]);
  }), 0)])]) : _vm._e()]), _vm._v(" "), _vm._l(_vm.templateContent[_vm.currentField].skills, function (skill, index) {
    return _c('clea-skill', {
      key: index,
      staticClass: "my-8",
      attrs: {
        "main-index": _vm.currentField,
        "secondary-index": index,
        "skill": skill
      },
      on: {
        "checked": function (index) {
          skill.criterions[index].check = true;
        },
        "unchecked": function (index) {
          skill.criterions[index].check = false;
        }
      }
    });
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "mb-5 md:mb-15 2xl:mb-20"
  }, [_c('h3', [_vm._v("\n      " + _vm._s(this.infosPage.libelle_template) + "\n    ")])]), _vm._v(" "), _c('list-buttons', {
    attrs: {
      "evaluation-in-progress": _vm.evaluationInProgress,
      "is-active": _vm.infosPage.is_active,
      "can-delete": false
    },
    on: {
      "preview": function () {
        _vm.showPreview = true;
      },
      "deactivateTemplate": function ($event) {
        return _vm.displayConfirmDeactivateTemplate();
      },
      "activateTemplate": function ($event) {
        return _vm.displayConfirmActivateTemplate();
      },
      "assignTemplate": function ($event) {
        return _vm.displayAssignTemplate();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mx-15"
  }, [_c('h3', {
    staticClass: "text-lg text-gray-600"
  }, [_vm._v("\n      Le référentiel Cléa n'est pas modifiable."), _c('br'), _vm._v("\n      Vous pouvez simplement\n      "), _vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_DESACTIVER) ? _c('span', [_vm._v("activer ou désactiver")]) : _c('span', [_vm._v("visualiser")]), _vm._v(" le modèle de page.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "my-15 flex justify-center"
  }, [_c('illustration', {
    attrs: {
      "name": "notAllowed"
    }
  })], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }